export class UtagHelper {
  static loadUtagJs() {
    if ((global as any).utagLoadAttempt) return;
    (global as any).utagLoadAttempt = true;
    const utagJsScript = document.createElement('script');
    utagJsScript.src = '//tms.ace.aaa.com/ace/prod/utag.js';
    utagJsScript.type = 'text/javascript';
    utagJsScript.async = true;
    document.body.appendChild(utagJsScript);
  }

  static tag(tags: any) {
    (global as any).aceMediaTagValues = { ...tags };
    if (typeof (global as any).utag === 'undefined') {
      this.loadUtagJs();
    } else {
      (global as any).utag.view((global as any).aceMediaTagValues);
    }
  }

  static link(tags: any) {
    (global as any).aceMediaTagValues = { ...tags };
    if (typeof (global as any).utag === 'undefined') {
      this.loadUtagJs();
    } else {
      (global as any).utag.link((global as any).aceMediaTagValues);
    }
  }

  static tagError(tags: any, page: string, error: string) {
    if (!tags || Object.keys(tags).length === 0) return {};

    let _page = tags.page || '';

    let tagPages: string[] = _page.split(':');
    tagPages.pop();

    return {
      ...tags,
      page: [...tagPages, page].join(':'),
      error: [...tagPages, error].join(':'),
    };
  }

  static tagPage(tags: any, page: string) {
    if (!tags || Object.keys(tags).length === 0) return {};

    let _page = tags.page || '';

    let tagPages: string[] = _page.split(':');
    tagPages.pop();

    return {
      ...tags,
      page: [...tagPages, page].join(':'),
    };
  }
}
